import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import { Input, Label } from "@/components/Forms";
import { ReactComponent as LinkIcon } from "@/assets/icons/link-box.svg";
import VideoReferenceModal from "./VideoReferenceModal";
import { ProductionVideoReferenceResource } from "@/types/resources";

const LinkInput = styled(Input)`
  height: 40px;
  font-size: 12px;
  line-height: 16px;
  flex: 1;
  border-radius: 4px 0px 0px 4px;
  color: ${({ theme }) => theme.colors.gray};
`;

const LinkinputHolder = styled.div`
  display: flex;
  flex: 1;
`;

const LinkButton = styled.button`
  background: ${({ theme }) => theme.colors.grayscale};
  border-radius: 0px 4px 4px 0px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.purple};
  flex-shrink: 0;
`;

const DetailsButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  color: ${({ theme }) => theme.colors.purple};
  border-radius: 4px;
  margin-left: 8px;
  flex-shrink: 0;
  transition: 0.2s ease-out border-color;
  &:hover {
    border-color: ${({ theme }) => theme.colors.purpleLight};
  }
`;

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${Label} {
    width: 100%;
  }
`;

interface Props {
  videoReference: ProductionVideoReferenceResource;
}

const VideoReferenceBlock: FC<Props> = ({ videoReference }) => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  return (
    <Box>
      <Label>{videoReference.name}</Label>
      <LinkinputHolder>
        <LinkInput
          placeholder="Video link"
          value={videoReference.url}
          readOnly
        />
        <LinkButton as="a" target="_blank" href={videoReference.url}>
          <LinkIcon />
        </LinkButton>
      </LinkinputHolder>
      <DetailsButton onClick={() => setShowDetailsModal(true)} type="button">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="7.25"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M7.86765 5.73529C7.52653 5.73529 7.25 5.45876 7.25 5.11765C7.25 4.77653 7.52653 4.5 7.86765 4.5H8.13235C8.47347 4.5 8.75 4.77653 8.75 5.11765C8.75 5.45876 8.47347 5.73529 8.13235 5.73529H7.86765ZM8 11.5C7.58579 11.5 7.25 11.1642 7.25 10.75V7.30882C7.25 6.89461 7.58579 6.55882 8 6.55882C8.41421 6.55882 8.75 6.89461 8.75 7.30882V10.75C8.75 11.1642 8.41421 11.5 8 11.5Z"
            fill="currentColor"
          />
        </svg>
      </DetailsButton>
      <AnimatePresence>
        {showDetailsModal && (
          <VideoReferenceModal
            onClose={() => setShowDetailsModal(false)}
            externalVideoId={videoReference.videoId}
          />
        )}
      </AnimatePresence>
    </Box>
  );
};

export default VideoReferenceBlock;
